<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 md6>
        <h2></h2>
      </v-flex>
      <v-flex xs12 md3 style="text-align: end;">
        <v-btn color="secondary"  @click="exportExcel" v-if="myPermissions.includes(17)" :style="dark_t?'color:black':''">
          <v-icon></v-icon>
          <span>Exportar Excel</span>
        </v-btn>
      </v-flex>
      <v-flex xs12 md3 style="text-align: end;">
        <label for="file-upload-kris" class="custom-file-upload textAlignCenter fullWidth" v-if="myPermissions.includes(15)">
          <v-icon>attach_file</v-icon>
          <fs1-span> Cargar KRI</fs1-span>
          <input id="file-upload-kris" class="btn" type="file" @change="selectFile($event.target.files)">
        </label>
		<fs1-div>Fecha de última carga: {{formalDateFormat(sheet_update)}}</fs1-div>
      </v-flex>
    </v-layout>
		<br>
    <v-layout wrap>
      <v-flex md9>
        <h3>Individual asset reports</h3>
      </v-flex>
      <v-flex md3 style="text-align: end;">
        <v-btn color="primary" @click="dialog = true" v-if="myPermissions.includes(19)">
          <v-icon>edit</v-icon>
          <span>Editar KRI 1 y KRI 2</span>
        </v-btn>
      </v-flex>
    </v-layout>

		<br>
		<v-data-table
			:headers="headers"
			:items="rows"
			class="tablaLT1"
			:class="dark_t?'dark':''"
			hide-default-footer>
			<template v-slot:item="props">
				<tr>
					<td v-for="(v,i) in headers" :key="i">
						<div v-for="(val, ii) in split_text(props.item[v.value])" :key="ii" :style="(i+1) === headers.length? '':'text-align:left'">
							<fs1-span>{{ val }}</fs1-span>
						</div>
					</td>
				</tr>
			</template>
			<template v-slot:no-data>
				<v-icon>warning</v-icon>
				Sin Información.
			</template>
		</v-data-table>

    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card class="pa-40 textAlignCenter">
        <h2 class="dark-orange--text">Editar KRI 1 y 2</h2>
        <br>
				<br>
				<div>
          <v-text-field placeholder=" Ingresar"
						label="KRI 1"
            clearable
						type="number"
            prepend-icon="edit" 
            :class="!selectedItem.kri1 && 'textEmpty'"
            v-model="selectedItem.kri1"/>
				</div>
				<br>
				<div>
          <v-text-field placeholder=" Ingresar"
						label="KRI 2"
            clearable
						type="number"
            prepend-icon="edit" 
            :class="!selectedItem.kri2 && 'textEmpty'"
            v-model="selectedItem.kri2"/>
				</div>
				<br>
				<p v-if="dialogError">
          <v-icon class="pulse_warning">warning</v-icon>
          <fs1-span>
            <b>Solo valores entre 0 y 100</b>
          </fs1-span>
				</p>
        <div>
          <v-btn color="secondary" @click="dialog = false">
            <span>Cancelar</span>
          </v-btn>
          <v-btn color="primary" @click="edit">
						<v-icon>save</v-icon>
            <span>Guardar</span>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
	</div>
</template>

<script>
import { uploadKRI, getExportKri  as exportExcel, getDashboardKriIndividualTable, edit_kri_1_2 } from '@/requests/ac';
import SheetUpdate from '@/components/mixins/SheetUpdate';

export default {
	mixins: [SheetUpdate],
  data() {
    return {
			sheet_update_key:'kri',
			dialogError:false,
			selectedItem:{
				kri1:null,
				kri2:null,
			},
			dialog:false,
			data:{
				headers:{},
				detail:[],
			}
    };
  },
  computed: {
    headers() {
			const h = [];
			Object.keys(this.data.headers).forEach(value => {
				h.push({ sortable: false, text: this.data.headers[value], value });
			})
			return h
		},
    rows() { return this.data.detail },
	},
	async created(){
		if(!await this.assignAccess()) return this.getError('no se pudo obtener acceso');
		getDashboardKriIndividualTable()
			.then(r => r && (this.data = r));
	},
  methods: {
		async exportExcel(){
      this.setProgress({show:true,message:'Cargando...'});
			if(!await this.assignAccess()) return;
			exportExcel()
        .then(r => this.setProgress({show:false}))
        .catch(e => this.getError(e));
		},
    async selectFile(files) { // files no es un array por lo que sus proto funciones no aplican
      if(files.length === 0) return;
			this.setProgress({message:'Guardando...',show:true});
			if(!await this.assignAccess()) return;
      uploadKRI({file:files[0]})
        .then(r => {
          console.warn(r)
          this.setProgress({show:false});
          r.message === 'success'
            ? this.setSnackbar({message: 'Guardado.', class: 'success'}) || this.reGetSheetUpdate()
            : this.setSnackbar({message: 'Problema.', class: 'error'});
        })
        .catch(e => this.getError(e));
		},
		async edit(){
			const {kri1,kri2} = this.selectedItem;
			if (isNaN(kri1) || isNaN(kri2)){
				 this.dialogError = true;
				 return;
			} else{
				if ((kri1 > 100 || kri1 < 0) || (kri2 > 100 || kri2 < 0)) {
					this.dialogError = true;
					return;
				}
			}
			this.dialogError = false;
			this.dialog = false;
      this.setProgress({show:true,message:'Cargando...'});
			if(!await this.assignAccess()) return;
			edit_kri_1_2(this.selectedItem)
        .then(r => {
					this.setProgress({show:false})
					getDashboardKriIndividualTable()
						.then(r => r && (this.data = r));
				})
        .catch(e => this.getError(e));
		}
  }, // methods
};
</script>
